<template>
  <el-table-column
    prop="net_price"
    sortable="custom"
    label="Nettó ár"
    show-overflow-tooltip
    min-width="130"
  >
    <template slot-scope="scope">
      {{ scope.row.net_price | currency(scope.row.currency.code) }}
    </template>
  </el-table-column>
</template>

<script>
export default {
  propName: 'net_price',
};
</script>
